/** @format */

export const NoPlanLabel = 'No Plan';
export const NoPlanKey = 'No Plan Key';
